<template>
    <div class="content-left">
        <!-- 创建按钮 -->
        <div class="create-btn">
            <button @click="handleCreate">+ 创建可视化项目</button>
        </div>

        <!-- 菜单列表 -->
        <div v-for="item in menuItems" :ref="`ref${item.id}`" :key="item.id" class="menu-item" :class="{ active: activeId === item.id }"
            @click="handleMenuClick(item)">
            <img :src="getImageUrl(activeId == item.id ? item.hover : item.default)" alt="" v-if="activeId == item.id">
            <img :src="getImageUrl(item.icon || item.default)" alt="" v-else>
            <span class="menu-text">{{ item.name }}</span>
        </div>

        <!-- 分隔线和其他内容 -->
        <div class="divider"></div>
        <img :src="getImageUrl('leftAd.png')" class="ad-image" @click="openvideo">
        <div class="apply" @click="toapply" v-if="userinfo.role_id == -1">
            <img src="@/assets/icon12.png" alt="" class="apply-icon">
            试用申请
            <img src="@/assets/return.png" alt="" class="right-point">
        </div>
        <div class="pay-tips" v-if="userinfo && (userinfo.role_id || userinfo.role_id === 0)">
            <img :src="rolemap[userinfo.role_id].icon" alt="" v-if="rolemap[userinfo.role_id].icon">
            {{ getLevelName(userinfo.role_id) }}{{ lesstime == '-1天' ? '' : `：剩余${lesstime}` }}
            <div class="uplevel" @click="openpaylog">{{ userinfo.role_id == 0 ? '前往升级' : '会员续费'}} ></div>
        </div>
        <div class="timer-line" :class="{'blue-linear': userinfo.role_id > 0}"></div>
        <div class="divider"></div>
        <div class="footer">
            <div class="copyright">福州今领信息科技有限公司 版权所有</div>
            <div class="version">BETA 0.1.1</div>
        </div>
    </div>
</template>
  
<script>
import icon1 from '@/assets/pay/vip-icon.png'
import icon2 from '@/assets/pay/vip-icon2.png'
import { getusertime } from '@/api/new'

export default {
    data() {
        return {
            activeId: 'mypro',
            menuItems: [
                { id: 'mypro', name: '我的项目', default: 'icon_1_0.png', hover: 'icon_1.png' },
                // { id: 'custompro', name: '定制项目', default: 'icon_2_0.png', hover: 'icon_2_1.png' },
                { id: 'mycomp', name: '我的组件', default: 'icon_4_0.png', hover: 'icon_4_1.png' },
                // { id: 'recycle', name: '回收站', default: 'icon_3_0.png', hover: 'icon_3_1.png' },
            ],
            rolemap: {
                '-1': {name: '普通版', icon: '' },
                '0': {name: '试用版', icon: '' },
                '1': {name: '月费会员', icon: icon1 },
                '2': {name: '年费会员', icon: icon2 },
            },
            userinfo: {},
            lesstime: '',
        }
    },
    methods: {
        handleCreate() {
            this.$emit('opencteate');
        },
        handleMenuClick(item) {
            if (this.activeId == item.id || item.id == 'custompro' || item.id == 'recycle') return;
            this.activeId = item.id;
            this.$emit('menuclick', item.id)
            // 这里可以添加路由跳转逻辑
        },
        getImageUrl(filename) {
            return require(`@/assets/${filename}`);
        },
        menuEvent() {
            this.menuItems.forEach(item => {
                let refname = 'ref' + item.id
                const dom = this.$refs[refname][0]
                dom.addEventListener('mouseenter', () => {
                    item.icon = item.hover
                    this.menuItems = [...this.menuItems]
                })
                dom.addEventListener('mouseleave', () => {
                    item.icon = item.default
                    this.menuItems = [...this.menuItems]
                })
            })
        },
        openpaylog() {
            this.$emit('openpaylog')
        },
        getLevelName(level) {
            return this.rolemap[+level].name
        },
        updateInfo() {
            this.getLesstime()
            // this.userinfo = JSON.parse(localStorage.getItem('userInfor'))
        },
		// 获取会员剩余时长
		getLesstime() {
			getusertime().then(res => {
                if (res.status == 200) {
                    this.lesstime = res.data.left_time
                    let userinfo = JSON.parse(localStorage.getItem('userInfor'))
                    userinfo.left_time = res.data.left_time
                    userinfo.left_time_num = res.data.left_time_num
                    if (res.data.left_time_num == '-1') {
                        userinfo.role_id = -1
                        this.$emit('isout', userinfo)
                    }
                    if (res.data.user_level !== userinfo.role_id) {
                        userinfo.role_id = res.data.user_level
                    }
                    localStorage.setItem('userInfor', JSON.stringify(userinfo))
                    this.userinfo = userinfo
                }
			})
		},
        toapply() {
            this.$emit('showapply', true)
        },
        openvideo() {
            this.$emit('openvideo')
        }
    },
    mounted() {
        this.menuEvent()
        setTimeout(() => {
    		this.getLesstime()
        }, 500);
        this.userinfo = JSON.parse(localStorage.getItem('userInfor'))
    }
}
</script>
  
<style lang="scss" scoped>
.content-left {
    width: 20%;
    max-width: 340px;
    padding: 0 0 0 25px;
    background: #121212;
    display: flex;
    flex-direction: column;
}

.create-btn {
    width: 90%;
    height: 60px;
    border-radius: 5px;
    background: linear-gradient(to left, #62b0f8, #2592f7);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 25px;

    button {
        background: none;
        border: none;
        font-size: 17px;
        color: #fff;
        font-family: 'Hei';
        cursor: pointer;
    }
}

.menu-item {
    width: 81%;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    margin: 6px 0;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #a0a0a0;

    img {
        width: 16px;
        height: 16px;
        margin-right: 12px;
        transition: all 0.3s ease;
    }

    &:hover,
    &.active {
        color: #fff;
        background: #2b2d32;
    }
}

.divider {
    width: 90%;
    height: 1px;
    background: #2a2a2a;
    margin: 25px 0;
}

.ad-image {
    width: 90%;
    margin-bottom: 25px;
    cursor: pointer;
}

.footer {
    margin-top: 16px;
    color: #a0a0a0;
    font-size: 14px;
    font-family: 'Hei';
    margin-bottom: 40px;
    .version {
        margin-top: 1vh;
    }
}
.menu-text {
    font-size: 14px;
}
.pay-tips {
    margin-top: auto;
    display: flex;
    align-items: center;
    padding-right: 38px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #A0A0A0;
    line-height: 23px;
    .uplevel {
        margin-left: auto;
        color: #2584FF;
        cursor: pointer;
    }
    img {
        width: 24px;
        height: 22px;
        margin-right: 6px;
    }
}
.timer-line {
    width: 90%;
    height: 9px;
    background: #2B2D32;
    border-radius: 4px;
    margin: 20px 0 0;
    &.blue-linear {
        background: linear-gradient(-90deg, #62B0F8, #2483FF);
    }
}
.apply {
    padding-bottom: 24px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #2A2A2A;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #A0A0A0;
    line-height: 14px;
    width: 90%;
    cursor: pointer;
    .apply-icon {
        width: 21px;
        height: 21px;
        margin: 0 21px 0 8px;
    }
    .right-point {
        margin: 0 16px 0 auto;
        width: 7px;
        height: 12px;
        transform: rotate(180deg);
    }
}
</style>